import localeText from '@/locales/datagrid'
import { insensitive } from '@acme/common'
import { Box, Switch, TextField } from '@mui/material'
import { Button } from 'global/components/Button'
import { useThemeStore } from 'global/components/ToggleTheme'
import { SearchIcon } from 'lucide-react'
import React from 'react'
import { useTableApiContext } from '../utils/table-context'

export default function ColumnVisibility() {
    const { columns, setColunas } = useTableApiContext()

    const colunasFiltraveis = columns.filter(c => c.hideable !== false)
    const [colunasPesquisa, setColunasPesquisa] = React.useState(
        colunasFiltraveis.map(c => c.field),
    )
    const theme = useThemeStore(state => state.theme)

    return (
        <Box
            sx={{
                padding: '2px',
                height: '150px',
                maxHeight: '150px',
                border:
                    theme === 'dark'
                        ? '1px solid rgba(81, 81, 81, 1)'
                        : '1px solid rgba(224, 224, 224, 1);',
                borderBottom: 'none',
                display: 'flex',
                flexDirection: 'row',
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    display: 'grid',
                    gridTemplateColumns:
                        'repeat(auto-fill, minmax(250px, 1fr))',
                    gridTemplateRows: 'min-content',
                    overflowY: 'auto',
                    overflowWrap: 'break-word',
                    float: 'left',
                    height: '100%',
                    mr: '10px',
                }}
            >
                {colunasFiltraveis
                    .filter(c => colunasPesquisa.includes(c.field))
                    .map(column => {
                        return (
                            <div key={column.field}>
                                <Switch
                                    checked={!column.hide}
                                    onChange={event => {
                                        const value = event.target.checked
                                        setColunas(
                                            columns.map(c =>
                                                c.field === column.field
                                                    ? {
                                                          ...c,
                                                          hide: !value,
                                                      }
                                                    : c,
                                            ),
                                        )
                                    }}
                                />
                                <span style={{ userSelect: 'none' }}>
                                    {column.headerName ?? column.field}
                                </span>
                            </div>
                        )
                    })}
            </Box>
            <Box
                sx={{
                    width: '200px',
                    float: 'right',
                    padding: '6px',
                }}
            >
                <TextField
                    label={
                        <span style={{ marginLeft: 30 }}>
                            {localeText.columnsPanelTextFieldLabel}
                        </span>
                    }
                    size="small"
                    variant="outlined"
                    autoComplete="off"
                    InputLabelProps={{
                        sx: {
                            color: 'text.disabled',
                            opacity: 0.75,
                        },
                        shrink: false,
                    }}
                    InputProps={{
                        sx: {
                            color: 'text.disabled',
                            opacity: 0.5,
                        },
                        startAdornment: <SearchIcon className="size-5" />,
                    }}
                    onChange={event => {
                        const value = event.target.value
                        setColunasPesquisa(
                            colunasFiltraveis
                                .filter(c =>
                                    insensitive(
                                        c.headerName ?? c.field,
                                    ).includes(insensitive(value)),
                                )
                                .map(c => c.field),
                        )
                    }}
                />
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    fullWidth
                    sx={{ marginTop: '8px' }}
                    onClick={() => {
                        setColunas(prev =>
                            prev.map(c => ({
                                ...c,
                                hide:
                                    !colunasFiltraveis
                                        .map(f => f.field)
                                        .includes(c.field) && c.hideable,
                            })),
                        )
                    }}
                >
                    {localeText.columnsPanelShowAllButton}
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    fullWidth
                    sx={{ marginTop: '4px' }}
                    onClick={() => {
                        setColunas(prev =>
                            prev.map(c => {
                                if (c.hideable !== false)
                                    return {
                                        ...c,
                                        hide: true,
                                    }
                                return c
                            }),
                        )
                    }}
                >
                    {localeText.columnsPanelHideAllButton}
                </Button>
            </Box>
        </Box>
    )
}
